export default {"src":"/_next/static/media/ClinicalExcellence.75319ec8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};